import apiClient from '@/services/axios'

export const meInfo = () => {
  return apiClient.get('/coachs/me/info')
}
export const getTodoList = () => {
  return apiClient.get('/coachs/me/todo-list')
}
export const specifyHourInvation = (data: { startTime: string }, invitationId: string) => {
  return apiClient.post(`/coachs/me/invitations/${invitationId}/specify-hour`, data)
}

export const getStudents = (data: any) => {
  return apiClient.post(`/coachs/me/students?pageSize=25&page=${data.page}`, data)
}
export const getStudentDetail = (id: string) => {
  return apiClient.get(`/coachs/me/students/${id}`)
}
export const uploadPhoto = (data: any) => {
  return apiClient.post('/coachs/me/profile-photo', data)
}
export const getStudentCallInfo = (id: string) => {
  return apiClient.get(`/coachs/me/students/${id}/call-info`)
}
export const getStudentOnboardingInfo = (studentId: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/onboard-info`)
}

export const getStudentProgramDates = (studentId: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/programs`)
}
export const getStudentProgramWeekly = (studentId: string, weekId: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/programs-week/${weekId}`)
}
export const GetProgramAllDays = (studentId: string, programId: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/programs/${programId}/days`)
}
export const createTask = (studentId: string, dailyId: string, data: any) => {
  return apiClient.post(`/coachs/me/students/${studentId}/programs-daily/${dailyId}`, data)
}
export const updateTaskOrderCurrentDay = (studentId: string, dailyId: string, data: { taskId: string; newOrder: number }) => {
  return apiClient.put(`/coachs/me/students/${studentId}/programs-daily/${dailyId}`, data)
}
export const UpdateTask = (studentId: string, taskId: string, data: any) => {
  return apiClient.post(`/coachs/me/students/${studentId}/programs-tasks/${taskId}`, data)
}
export const GetTaskDetail = (taskId: string, studentId: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/programs-tasks/${taskId}`)
}

export const DeleteTask = (studentId: string, taskId: string) => {
  return apiClient.delete(`/coachs/me/students/${studentId}/programs-tasks/${taskId}`)
}

export const GetChatList = (pageNumber: number, search: string | null) => {
  return apiClient.get('/Chat/getChats', {
    baseURL: import.meta.env.VITE_APP_CHAT_BASE_URL,
    params: {
      search: search,
      pageSize: 20,
      page: pageNumber
    }
  })
}
export const GetMessageListByUser = (userId: string, date: string | null, limit: string | null) => {
  return apiClient.get('/Chat/getMessages', {
    params: {
      receiverId: userId,
      lastMessageDate: date,
      limit: limit
    }
  })
}

export const GetQuota = () => {
  return apiClient.get('/coachs/me/quota')
}
export const UpdateQuota = (data: any) => {
  return apiClient.post('/coachs/me/quota', data)
}
export const GetInvitationDayInfoPdr = () => {
  return apiClient.post('/coachs/me/students/invitation-day-info')
}

export const ChangePassword = (data: any) => {
  return apiClient.post('/coachs/me/change-password', data)
}
export const GetStudentsByDays = (data: any) => {
  return apiClient.post(
    '/coachs/me/students/invitation-day-info',
    {},
    {
      params: data
    }
  )
}
export const GetMentorAvailableDays = () => {
  return apiClient.post(`/coachs/me/reservation-days`)
}
export const ReserveDayStudent = (studentId: string, data: { day: string }) => {
  return apiClient.post(`/coachs/me/students/${studentId}/reserve-day`, data)
}
export const GetTopicProgress = (studentId: string, examType: string, course: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/topic-progression`, {
    params: {
      examType: examType,
      course: course
    }
  })
}
export const CreateProgression = (
  studentId: string,
  data: { studyTopicId: string; studentStudySourceId: string; topicProgression: string }
) => {
  return apiClient.post(`/coachs/me/students/${studentId}/topic-progression`, data)
}
export const UpdateProgression = (
  studentTopicProgressionId: string,
  studentId: string,
  data: { topicProgression: string }
) => {
  return apiClient.put(
    `/coachs/me/students/${studentId}/topic-progression/${studentTopicProgressionId}`,
    data
  )
}
export const CreateSource = (studentId: string, data: { name: string; examType: string; course: string }) => {
  return apiClient.post(`/coachs/me/students/${studentId}/study-source`, data)
}
export const GetAppointments = (startDate: string, endDate: string) => {
  return apiClient.get(`/coachs/me/weekly-todo-list/${startDate}/${endDate}`)
}
export const GetExamHistory = (studentId: string, examType: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/tests/summary/${examType}`)
}
export const GetExamDetail = (studentId: string, studentTestId: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/tests/${studentTestId}`)
}
export const GetExamTopics = (studentId: string, studentTestId: string, courseName: string) => {
  return apiClient.get(`/coachs/me/students/${studentId}/tests/${studentTestId}/topic-breakdown`, {
    params: {
      courseName: courseName
    }
  })
}
export const UploadFile = (data: any) => {
  return apiClient.post('/Chat/media', data)
}
